import {customElement, inject, DOM} from 'aurelia-framework';
import {EventAggregator} from 'aurelia-event-aggregator';
import {ContentService} from '../../../services/content-service';

@inject(EventAggregator, ContentService, Element)
@customElement('search-menu')
export class SearchMenu {

  buttonEl;
  showError=false;

  constructor(private __ea: EventAggregator, private __contentService: ContentService, private __el: Element) {
  }

  search(event) {
    event.preventDefault();

    if (event.type === 'click' || event.keyCode === '13' || event.which === '13') {
      let element = this.__el.querySelector('INPUT') as HTMLInputElement;
      if (element.value.length >= 3) {
        this.__ea.publish('DSSB:newGlobalSearch', {value: element.value});

        if (!DOM.getElementById('tab_search_people') || (DOM.getElementById('tab_search_people') as any).length === 0) {
          this.__contentService.openSearch().then(()=> {element.value = '';});
        } else {
          element.value = '';
        }

        return false;
      }

      this.showError = true;

    }
  }
}

